<ng-template #popupToolbarButton>
  <button
    [attr.data-testid]="testId"
    class="popup-toolbar-button"
    [ngClass]="{
      'popup-toolbar-button-selected': isSelected,
      'popup-toolbar-button-unselected': !isSelected,
      'video-selected': toolName === 'Video',
      hover: isHovering,
      'prek2-toolbar-button': isPreK2Reading,
      disabled: isButtonDisabled,
      'prek2-avatar-icon': hasPK2Avatar,
      'vo-in-progress': showVOInProgressAnim
    }"
    type="button"
    attr.aria-label="{{ toolName }} {{ 'TOOL_BAR.TOGGLE' | translate }}"
    (mouseover)="openTooltip()"
    (mouseout)="closeTooltip()"
    (click)="onClick($event)"
    [disabled]="isButtonDisabled">
    <div class="float-shadow"></div>
    <div class="tooltip">
      <div class="tooltip-text">{{ toolName }}</div>
    </div>
    @if (!hasPK2Avatar) {
      <svg-icon
        class="main-icon"
        [ngClass]="{
          small: iconSize === 'small',
          large: iconSize === 'large'
        }"
        src="{{ path + (isSelected && toggledIcon ? toggledIcon : icon) }}"
        attr.alt="{{ toolName }} {{
          'TOOL_BAR.TOGGLE' | translate
        }}"></svg-icon>
    } @else {
      <img
        class="main-icon"
        src="{{ path + (isSelected && toggledIcon ? toggledIcon : icon) }}"
        attr.alt="{{ toolName }} {{ 'TOOL_BAR.TOGGLE' | translate }}" />
    }
    @if (extraIcon.icon || extraIcon.toggledIcon) {
      <svg-icon
        class="additional-icon"
        src="{{ path + getExtraIcon() }}"
        attr.alt="{{ toolName }} {{
          'TOOL_BAR.EXTRA_ICON' | translate
        }}"></svg-icon>
    }
    @if (showVOInProgressAnim && isPreK2Reading && !isPaused) {
      <img
        class="vo-in-progress-animation"
        src="assets/toolbar-icons/VO-in-progress-animation.gif" />
    }
  </button>
</ng-template>
@if (isPreK2Reading) {
  <div class="prek2-button-container">
    <div
      class="box-shadow popup-toolbar-button prek2-toolbar-button"
      [class.disableshadow]="isDisabled"></div>
    <ng-container *ngTemplateOutlet="popupToolbarButton"></ng-container>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="popupToolbarButton"></ng-container>
}
